/* Discount reminder */

const discountProperty = '__eligible_for_discount';
const discountReminderDataLabel = '[data-discount-reminder]';
const discountReminderBarDataLabel = '[data-bar]';
const activeClass = 'discount-reminder__bar--active';

const createCartPromise = () => {
  return fetch(`${Shopify.routes.root}cart.js`).then(r => r.json());
};

const checkDiscount = (items) => {
  const reminders = document.querySelectorAll(discountReminderDataLabel);

  const eligibleItems = items
    .filter(item => item.properties[discountProperty] === 'true');

  const eligibleItemsCount = eligibleItems.reduce((n, { quantity }) => n + quantity, 0);

  reminders.forEach(reminder => {
    const bars = reminder.querySelectorAll(discountReminderBarDataLabel);
    bars.forEach(bar => bar.classList.remove(activeClass));

    const count = eligibleItemsCount > bars.length
      ? bars.length
      : eligibleItemsCount;

    for (let i = 0; i < count; i += 1) {
      bars[i].classList.add(activeClass);
    }
  });
};

const refreshDiscountFromCart = () => {
  // Lille delay så Shopify når at opdatere cart-state
  setTimeout(() => {
    createCartPromise().then(cart => {
      checkDiscount(cart.items);
    });
  }, 300);
};

const interceptCartRequests = () => {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url ?? '';

    const response = await originalFetch(...args);

    if (url.includes('/cart/add')) {
      refreshDiscountFromCart();
    }

    return response;
  };
};

const initCountListener = async () => {
  const cart = await createCartPromise();
  checkDiscount(cart.items);

  document.addEventListener('update-discount-reminder', (event) => {
    checkDiscount(event.detail.cart.items);
  });

  interceptCartRequests();
};

initDiscountReminder();

class CheckVariantElement extends HTMLElement {
  connectedCallback() {
    this.productOptionSelector = this.querySelector('[data-option-selector]');
    this.checkVariantSelect = this.querySelector('[data-check-variant-select]');

    if (!this.productOptionSelector || !this.checkVariantSelect) {
      console.warn('No productOptionSelector or checkVariantSelect')
      return;
    }

    this.AddEventListeners();
  }

  disconnectedCallback() {
    this.RemoveEventListeners();
  }
  
  AddEventListeners(){
    this.productOptionSelector.addEventListener('change', this.DispatchEventChangeVariant.bind(this));
    this.checkVariantSelect.addEventListener('click', this.CheckVariantSelect.bind(this));
  }

  RemoveEventListeners(){
    if (!this.productOptionSelector || !this.checkVariantSelect) {
      return;
    }
    this.productOptionSelector.removeEventListener('change', this.DispatchEventChangeVariant.bind(this));
    this.checkVariantSelect.removeEventListener('click', this.CheckVariantSelect.bind(this));
  }

  DispatchEventChangeVariant(){
    document.dispatchEvent(new CustomEvent('variant:change ', { bubbles: true }));
  }

  CheckVariantSelect(event){
    const inputs = this.productOptionSelector.querySelectorAll('input');
    const isAnyInputChecked = Array.from(inputs).some(input => input.checked);

    if (!isAnyInputChecked) {
      // Change border to red if no inputs are checked
      event.preventDefault();
      this.productOptionSelector.classList.add('custom-error');

      setTimeout(() => {
        this.productOptionSelector.classList.remove('custom-error');
      }, 1000);

    } else {
      // Submit the form as normal if any input is checked
      this.checkVariantSelect.children[0].type = 'submit';
    }
  }
}

customElements.define('check-variant', CheckVariantElement);